<template>
    <svg
        id="Component_109_2"
        data-name="Component 109 – 2"
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
    >
        <path
            id="Rectangle_551"
            data-name="Rectangle 551"
            d="M3,0h7a0,0,0,0,1,0,0V10a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3A3,3,0,0,1,3,0Z"
            fill="#854b97"
        />
        <path
            id="Rectangle_552"
            data-name="Rectangle 552"
            d="M0,0H7a3,3,0,0,1,3,3v7a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z"
            transform="translate(12)"
            fill="#854b97"
        />
        <path
            id="Rectangle_553"
            data-name="Rectangle 553"
            d="M0,0H10a0,0,0,0,1,0,0V7a3,3,0,0,1-3,3H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z"
            transform="translate(12 12)"
            fill="#854b97"
        />
        <path
            id="Rectangle_554"
            data-name="Rectangle 554"
            d="M0,0H10a0,0,0,0,1,0,0V10a0,0,0,0,1,0,0H3A3,3,0,0,1,0,7V0A0,0,0,0,1,0,0Z"
            transform="translate(0 12)"
            fill="#854b97"
        />
    </svg>
</template>
